import React from 'react';
import { useIntl } from 'react-intl';

const SearchNavBarHeader = ({ onClose, value, onChange }) => {
    const intl = useIntl();
    return (
        <div className="flex items-center px-2 py-2 bg-transparent rounded ml-2 w-full">
            <img style={{ filter: "invert(1) brightness(500%)" }} src="/images/icons/search-black.svg" height={14} width={14} alt="search" />
            <input
                type="text"
                className="ml-2 text-white bg-transparent outline-none w-full"
                placeholder={intl.formatMessage({ id: 'SEARCH', defaultMessage: 'Search' })}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                autoFocus
                placeholderColor
            />
            <div onClick={onClose} className="h-6 w-7 flex items-center justify-center cursor-pointer hover:bg-slate-600 rounded p-1 mx-2">
            <img
                src="/images/icons/close.svg"
                height={10}
                width={10}
                alt="close"
                style={{ filter: "invert(1) brightness(500%)" }}
            />
            </div>
        </div>
    );
};

export default SearchNavBarHeader;
